import React from "react";
import { Link } from "@/components/LocaleLink";
import { Phone, Mail, MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { CONTACT } from "@/i18n/translations";

const Footer = () => {
  const { t } = useLang();

  const links = [
    { to: "/ydelser", label: t.nav.ydelser },
    { to: "/indsatser", label: t.nav.indsatser },
    { to: "/kommuner-og-kriminalforsorgen", label: t.nav.kommuner },
    { to: "/akut-projekter", label: t.nav.akut },
    { to: "/udsatte", label: t.nav.udsatte },
    { to: "/adhd", label: t.nav.adhd },
    { to: "/autisme", label: t.nav.autisme },
    { to: "/kontakt", label: t.nav.kontakt },
  ];

  return (
    <footer className="bg-[#1A2E24] text-[#F7F5F0]" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-28">
        <div className="grid gap-14 lg:grid-cols-[1.4fr_1fr_1.2fr]">
          <div>
            <div className="flex items-center gap-2.5 mb-6">
              <img src="/assets/lotus-white.png" alt="Lotusgruppen" className="h-11 w-11 object-contain" />
              <span className="font-display text-2xl">Lotusgruppen</span>
            </div>
            <p className="text-[#8EA694] max-w-sm leading-relaxed">{t.footer.tagline}</p>
            <Link
              to="/kontakt"
              className="inline-flex mt-8 font-display text-3xl sm:text-4xl text-[#F7F5F0] hover:text-[#C47C5D] transition-colors duration-300"
              data-testid="footer-talk-link"
            >
              {t.footer.talk} →
            </Link>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] text-[#8EA694] mb-6 font-sans">{t.footer.nav}</h4>
            <ul className="space-y-3">
              {links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-[#EAE5D9]/80 hover:text-white transition-colors duration-300" data-testid={`footer-link-${l.to.slice(1)}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] text-[#8EA694] mb-6 font-sans">{t.footer.contact}</h4>
            <ul className="space-y-4 text-[#EAE5D9]/90">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#8EA694] shrink-0 mt-0.5" />
                <span>{t.kontakt.company}<br />Peter Sabroes Gade 7, 2th<br />2450 København SV</span>
              </li>
              <li>
                <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-3 hover:text-white transition-colors duration-300" data-testid="footer-phone">
                  <Phone className="h-5 w-5 text-[#8EA694]" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-white transition-colors duration-300" data-testid="footer-email">
                  <Mail className="h-5 w-5 text-[#8EA694]" /> {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-[#8EA694]">
          <span>© {new Date().getFullYear()} Lotusgruppen ApS. {t.footer.rights}</span>
          <span>Peter Sabroes Gade 7, 2450 København SV</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
